import { useCallback, useEffect, useRef, useState } from "react";
import { Container, Divider } from "@material-ui/core";
import { useSelector } from "react-redux";
import { Box, Grid } from "@mui/material";
import axios from "axios";
import {
  AutoCompleteWithSearch,
  BalanceCard,
  ModalError,
  MonthYearRangePicker,
  Page,
  SearchTextInput,
  SelectInput,
  SkeletonComponent,
  TableAction,
  YearPicker,
} from "components";
import { InnoTableV2 } from "inno-ui";
import { HeaderTitle } from "layouts";
import { getTotalPage } from "lib";
import { debounce } from "lodash";
import moment from "moment";
import { useHistory, useLocation } from "react-router";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import { getErrors } from "utils";
import { columnTable, optionsType } from "./Components/Constant";
import { ModalTotalRoyaltyTracking } from "./Components/Modal";

const RoyaltyTracking = () => {
  const classes = globalStyles();
  const location = useLocation();
  const urlPath = location.pathname;
  const isComposerInvoice = urlPath === "/admin/composer-invoice";

  const history = useHistory();
  const isFirstLoad = useRef(true);
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const urlParams = new URLSearchParams(location.search);
  const paramsSearch = urlParams?.get("search") || "";
  const paramsPage = urlParams?.get("page") || 1;
  const paramsSize = urlParams?.get("size") || 10;
  const paramsYear = urlParams?.get("year");
  const paramsDSP = urlParams?.get("dsp_id");
  const pageTitle = `Royalty Tracking`;
  const pageUrl = `sales-invoice`;
  const [optionClient, setOptionClient] = useState([]);
  const [optionUser, setOptionUser] = useState([]);
  const [loadingPage, setLoadingPage] = useState(false);
  const [dataTable, setDataTable] = useState([]);
  const [queryParams, setQueryParams] = useState({
    page: Number(paramsPage) || 1,
    size: Number(paramsSize) || 10,
    search: paramsSearch || "",
    type: "",
    sort: "",
    year: Number(paramsYear) || moment().year(),
    dsp_id: Number(paramsDSP) || "",
  });
  const [tableTotalPage, setTableTotalPage] = useState(1);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalFilter, setModalFilter] = useState("");
  const [loadingFilter, setLoadingFilter] = useState(false);
  const [loadingFilterUser, setLoadingFilterUser] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const [hasMoreUser, setHasMoreUser] = useState(false);
  const [filterParams, setFilterParams] = useState({
    page: 1,
    size: 10,
    search: "",
  });
  const [filterParamsUser, setFilterParamsUser] = useState({
    page: 1,
    size: 10,
    search: "",
  });
  const [localFilterSearch, setLocalFilterSearch] = useState("");
  const filteredOptions = isComposerInvoice
    ? optionClient
    : optionClient.filter(client =>
        client?.dsp_name.toLowerCase().includes(localFilterSearch.toLowerCase())
      );

  const clientValue = optionClient.find(option =>
    isComposerInvoice
      ? option.id === queryParams?.composer_id
      : option.id === queryParams?.dsp_id
  );
  const cardRoyaltyTracking = [
    {
      key: 1,
      title: "Total Revenue",
      value: dataTable?.total_revenue,
      status: "revenue",
    },
    {
      key: 2,
      title: "Total Composer/Author",
      value: dataTable?.total_composer_revenue,
      status: "composer_revenue",
    },
    {
      key: 3,
      title: "Total Paid",
      value: dataTable?.total_paid_revenue,
      status: "paid",
    },
    {
      key: 4,
      title: "Total Unpaid",
      value: dataTable?.total_unpaid_revenue,
      status: "unpaid",
    },
  ];
  const handleChangePageParams = (value, key) => {
    urlParams.set(key, value);
    history.replace({
      pathname: location.pathname,
      search: urlParams.toString(),
    });
  };
  const handleChangeQueryParams = (value, key) => {
    setQueryParams(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
    handleChangePageParams(value, key);
    if (key !== "page") {
      handleChangePageParams(1, "page");
    }
  };

  const handleChangeYear = year => {
    handleChangeQueryParams(year, "year");
    const { start_date, end_date } = queryParams;
    if (start_date && end_date) {
      const newStartDate = moment(start_date)
        .startOf("month")
        .year(year);
      let newEndDate = moment(end_date)
        .endOf("month")
        .year(year);
      let maxAllowedDate;
      const currentYear = moment().year();

      if (year === currentYear) {
        maxAllowedDate = moment().endOf("month");
      } else {
        maxAllowedDate = moment()
          .year(year)
          .endOf("year");
      }

      if (newEndDate > maxAllowedDate) {
        newEndDate = maxAllowedDate;
      }

      handleChangeStartDate(newStartDate);
      handleChangeEndDate(newEndDate);
    }
  };
  const handleChangeStartDate = date => {
    handleChangeQueryParams(date, "start_date");
  };
  const handleChangeEndDate = date => {
    handleChangeQueryParams(date, "end_date");
  };
  const handleChangeFilterParams = (value, key) => {
    setFilterParams(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
  };
  const handleChangeFilterParamsUser = (value, key) => {
    setFilterParamsUser(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
  };

  const getClientList = async () => {
    const url = isComposerInvoice
      ? "publisher/transaction/v2/composer-invoice/list-composer"
      : "master/all-client";
    try {
      setLoadingFilter(true);
      const res = await axios.get(`${hardBaseUrl}/${url}`, {
        headers,
        params: isComposerInvoice
          ? {
              ...filterParams,
              year: queryParams?.year,
            }
          : {},
      });
      const { data, meta } = res?.data;
      const newOptions = data?.map(item => ({
        ...item,
        id: isComposerInvoice ? item?.composer_id : item?.dsp_id,
      }));

      setOptionClient(prev => {
        const combined =
          filterParams.page === 1 ? newOptions : [...prev, ...newOptions];

        setHasMore(meta?.total > combined?.length);
        return isComposerInvoice ? combined : newOptions;
      });
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingFilter(false);
    }
  };

  const debounceFilterClient = useCallback(
    debounce(() => {
      getClientList();
    }, 500),
    [filterParams, queryParams?.year]
  );

  const getDataTable = async () => {
    try {
      setLoadingPage(true);
      const { start_date, end_date, ...restQueryParams } = queryParams;
      const res = await axios.get(
        `${hardBaseUrl}/publisher/royalty-tracking/v1/sales-invoice/list`,
        {
          headers,
          params: {
            ...restQueryParams,
          },
        }
      );
      const { data, meta } = res?.data;
      setDataTable(data || []);
      const pageCount = getTotalPage(meta?.total, queryParams?.size || 1);
      setTableTotalPage(pageCount);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };
  const debounceDataTable = useCallback(
    debounce(() => {
      getDataTable();
    }, 500),
    [queryParams]
  );
  const getOptionUser = async () => {
    try {
      setLoadingFilterUser(true);
      const res = await axios.get(
        `${hardBaseUrl}/publisher/transaction/v2/composer-invoice/list-generated-by`,
        {
          headers,
          params: filterParamsUser,
        }
      );
      const { data, meta } = res?.data;
      const newOptions = data?.map(item => ({
        ...item,
        id: item?.user_id,
      }));

      setOptionUser(prev => {
        const combined =
          filterParams.page === 1 ? newOptions : [...prev, ...newOptions];

        setHasMoreUser(meta?.total > combined?.length);
        return isComposerInvoice ? combined : newOptions;
      });
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingFilterUser(false);
    }
  };
  const debounceFilterUser = useCallback(
    debounce(() => {
      getOptionUser();
    }, 500),
    [filterParamsUser, queryParams?.year]
  );

  const fetchData = async () => {
    setLoadingPage(true);
    const promises = [getDataTable()];
    if (isFirstLoad.current) {
      promises.push(getClientList());
      promises.push(getOptionUser());
    }

    try {
      await Promise.all(promises);
    } catch (error) {
      ModalError(error, "Error fetching data");
    } finally {
      setLoadingPage(false);
      isFirstLoad.current = false;
    }
  };

  useEffect(() => {
    const isSearching = Boolean(queryParams?.search);
    if (isSearching) {
      debounceDataTable();
      return () => {
        debounceDataTable.cancel();
      };
    } else {
      fetchData();
    }
  }, [queryParams, debounceDataTable]);

  useEffect(() => {
    if (!isFirstLoad.current && isComposerInvoice) {
      const isSearching = Boolean(filterParams?.search);
      if (isSearching) {
        debounceFilterClient();
        return () => {
          debounceFilterClient.cancel();
        };
      } else {
        getClientList();
      }
    }
  }, [filterParams, debounceFilterClient]);
  useEffect(() => {
    if (!isFirstLoad.current && isComposerInvoice) {
      const isSearching = Boolean(filterParams?.search);
      if (isSearching) {
        debounceFilterUser();
        return () => {
          debounceFilterUser.cancel();
        };
      } else {
        getOptionUser();
      }
    }
  }, [filterParamsUser, debounceFilterUser]);

  return (
    <Page className={classes.root} title={"Royalty Tracking"}>
      <Container maxWidth={false}>
        <HeaderTitle
          title={"Royalty Tracking"}
          breadcrumbData={breadcrumbData({ pageTitle, pageUrl })}
        />
        <Divider className={classes?.flatDivider} />
        <Grid container columnGap={2} my="16px">
          <Grid item>
            <AutoCompleteWithSearch
              placeholder={`DSP`}
              label={"DSP"}
              options={filteredOptions}
              value={clientValue || null}
              onChange={value => handleChangeQueryParams(value?.id, "dsp_id")}
              inputValue={localFilterSearch}
              onInputChange={value => setLocalFilterSearch(value)}
              optionLabel={"dsp_name"}
              setQueryParams={isComposerInvoice && setFilterParams}
              hasMore={isComposerInvoice && hasMore}
              loading={loadingFilter}
              width={300}
            />
          </Grid>
          <Grid item>
            <YearPicker
              label="Year"
              onChange={handleChangeYear}
              value={queryParams?.year}
              width={200}
            />
          </Grid>
        </Grid>
        <Box display="flex" overflow="auto" gap={2} mt="16px">
          {cardRoyaltyTracking?.map((item, index) => {
            return (
              <Box flexShrink={0} key={index}>
                <BalanceCard
                  title={item?.title}
                  value={item?.value}
                  infoButton
                  tooltipTitle={item?.title}
                  onClick={() => {
                    setModalVisible(true);
                    setModalTitle(item?.title);
                    setModalFilter(item?.status);
                  }}
                  loading={loadingPage}
                  minWidth={280}
                  showDollar={false}
                />
              </Box>
            );
          })}
        </Box>
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          my={2}
          rowSpacing={1}
        >
          <Grid item>
            <Grid container columnSpacing={1} alignItems="center">
              <Grid item>
                <SearchTextInput
                  placeholder="Search"
                  value={queryParams?.search}
                  onChange={e =>
                    handleChangeQueryParams(e?.target?.value, "search")
                  }
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Grid container columnSpacing={1} alignItems="center">
              {isComposerInvoice && (
                <Grid item>
                  <AutoCompleteWithSearch
                    placeholder="All User"
                    label="Generated By"
                    options={optionUser}
                    value={
                      optionUser?.find(
                        item => item?.id === queryParams?.generated_by
                      ) || null
                    }
                    onChange={value =>
                      handleChangeQueryParams(value?.id, "generated_by")
                    }
                    inputValue={filterParamsUser?.search}
                    onInputChange={value =>
                      handleChangeFilterParamsUser(value, "search")
                    }
                    optionLabel={"user_name"}
                    setQueryParams={setFilterParamsUser}
                    hasMore={hasMoreUser}
                    loading={loadingFilterUser}
                    width={300}
                  />
                </Grid>
              )}
              <Grid item>
                {isComposerInvoice ? (
                  <MonthYearRangePicker
                    key={queryParams?.year}
                    label="Period"
                    startDate={queryParams?.start_date}
                    handleChangeStartDate={handleChangeStartDate}
                    endDate={queryParams?.end_date}
                    handleChangeEndDate={handleChangeEndDate}
                    clear
                    width={300}
                    syncYear
                    predefinedYear={queryParams?.year}
                  />
                ) : (
                  <SelectInput
                    label="Type"
                    placeholder="None"
                    value={queryParams?.type}
                    onChange={e =>
                      handleChangeQueryParams(e?.target?.value, "type")
                    }
                    options={optionsType}
                    optionKey="value"
                    optionLabel="name"
                    width={200}
                  />
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Divider className={classes?.divider} />
        {loadingPage ? (
          <SkeletonComponent variant="wave" />
        ) : (
          <InnoTableV2
            isLoading={false}
            columns={columnTable()}
            items={dataTable?.list || []}
            page={queryParams?.page}
            rowsPerPage={queryParams?.size}
            totalPage={tableTotalPage}
            handleChangePage={(_, page) =>
              handleChangeQueryParams(page, "page")
            }
            handleChangeRowsPerPage={e =>
              handleChangeQueryParams(e?.target?.value, "size")
            }
            isHaveAction
            renderAction={item => {
              const { invoice_id } = item;
              return (
                <TableAction
                  width={5}
                  tooltipView="View"
                  handleView={() =>
                    history.push({
                      pathname: `/admin/royalty-tracking/${invoice_id}`,
                    })
                  }
                />
              );
            }}
          />
        )}
        {modalVisible && (
          <ModalTotalRoyaltyTracking
            open={modalVisible}
            onClose={() => setModalVisible(false)}
            title={modalTitle}
            params={queryParams}
            filter={modalFilter}
          />
        )}
      </Container>
    </Page>
  );
};

const breadcrumbData = ({ pageTitle, pageUrl }) => [
  {
    label: "Home",
    link: "/admin/dashboard",
  },
  {
    label: "Transaction",
    link: `/admin/${pageUrl}`,
  },
  {
    label: pageTitle,
    active: true,
  },
];

export default RoyaltyTracking;
